<!--
  Иконка калибровки: ползунки точной настройки
  Используется в блоках настройки калибровки датчиков
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <line
      x1="4"
      y1="9"
      x2="20"
      y2="9"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
    <line
      x1="4"
      y1="15"
      x2="20"
      y2="15"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle
      cx="9"
      cy="9"
      r="2"
      fill="#fff"
      :stroke="stroke"
      stroke-width="2"
    />
    <circle
      cx="15"
      cy="15"
      r="2"
      fill="#fff"
      :stroke="stroke"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: "CalibrationIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
